import { DatePicker, Form, Input, Select } from 'antd';
import dayjs from 'dayjs';
import { localize } from 'mixins/helpers';
import React, { FC } from 'react';
import { MONTH_NUMBERS_TYPES } from '/react4xp/parts/calc-transport/calc-transport-consts';

const CarForm: FC = (props: any) => {
    const handleEngineVolumeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // Allow only digits
        const value = e.target.value.replace(/\D/g, '');
        e.target.value = value;
    };
    return (
        <Form
            form={props.form}
            className="w-100"
        >
            <Form.Item
                name="year"
                rules={[
                    {
                        required: true,
                        message: localize('meta.error.invalid-data', props.translations),
                    },
                ]}
            >
                <DatePicker
                    placeholder={localize('calc-transport-criteria-2', props.translations)}
                    format={'YYYY'}
                    picker="year"
                    maxDate={dayjs()}
                />
            </Form.Item>

            <Form.Item
                name="numberOfMonthsInUse"
                rules={[
                    {
                        required: true,
                        message: localize('meta.error.invalid-data', props.translations),
                    },
                ]}
            >
                <Select
                    options={MONTH_NUMBERS_TYPES}
                    placeholder={localize('calc-transport-criteria-3', props.translations)}
                    allowClear
                />
            </Form.Item>

            <Form.Item
                name="carEngineVolume"
                rules={[
                    {
                        required: true,
                        message: localize('meta.error.invalid-data', props.translations),
                    },
                ]}
            >
                <Input
                    type="number"
                    min="0"
                    onChange={handleEngineVolumeChange}
                    onKeyUp={(e) => {
                        // Prevent non-digit characters from being typed
                        if (
                            !/[0-9]/.test(e.key) &&
                            !['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'].includes(e.key)
                        ) {
                            e.preventDefault();
                        }
                    }}
                    placeholder={localize('calc-transport-criteria-8', props.translations)}
                    suffix={
                        <>
                            см<sup>3</sup>
                        </>
                    }
                />
            </Form.Item>
        </Form>
    );
};

export default CarForm;
